import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	Input
} from '@angular/core';

import { VgStates } from '../VgStates';

@Component({
	selector: 'vg-poster',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		@if (vgUrl) {
			<img
				class="image"
				[hidden]="!isStopped"
				[src]="vgUrl"
				vbImageLoad
				role="presentation"
				alt=""
			/>
		}
	`,
	standalone: false,
	styleUrls: ['./VgPoster.Component.ng.less']
})
export class VgPosterComponent {
	@Input() public currentState: VgStates;
	@Input() public vgUrl: string;

	@HostBinding('class.vgPosterRootStopped')
	public get isStopped(): boolean {
		return this.currentState === VgStates.STOP;
	}
}
